<div class="statistics__container">
	<div class="statistics__header">
		<h1>{{ 'admin.product.statistics.title.header' | translate }}</h1>
	</div>
	<div class="statistics__view">
		<div class="statistics__view-selector">
			<pf-select
				[options]="viewOptions()"
				[initialSelectedId]="selectedView()"
				(singleSelectionChange)="onChangeView($event)" />
		</div>
		@if (selectedView() === 'productView') {
			<app-productstatistic />
		}

		@if (selectedView() === 'partnerView') {
			<app-partnerstatistic />
		}

		@if (selectedView() === 'festivalView') {
			<app-festivalstatistic />
		}
	</div>
</div>
